<template>
    <transition name="modal" v-if="isActive">
        <div class="modal-mask">
            <div class="modal-form modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            {{ $PPlusEngine.getDictionary($route.params.lang, 'ลืมรหัสผ่าน', 'Forget Password') }}
                            <button @click="hide()"><font-awesome-icon :icon="['fas', 'times']" /></button>
                        </h4>
                    </div>        
                    <div class="modal-body">
                        <div class="form-group">
                            <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'อีเมล', 'Email') }}</label>
                            <input type="email" class="form-control" placeholder="email@website.com" maxlength="100" :class="$PPlusEngine.highlightInvalidField(forgetPasswordValidate.email.invalid)" v-model="forgetPasswordForm.email" @keyup.enter="submitForgetPassword()" />
                            <span class="error-message" v-if="forgetPasswordValidate.email.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้กรอกอีเมล', 'Please input your email') }}</span>
                            <span class="error-message" v-if="forgetPasswordValidate.email.format">{{ $PPlusEngine.getDictionary($route.params.lang, 'รูปแบบอีเมลไม่ถูกต้อง', 'Email format is invalid') }}</span>
                        </div>
                        <span class="error-message" v-if="forgetPasswordValidate.form.invalid">{{ forgetPasswordValidate.form.message }}</span>
                        <div class="action">
                            <button class="btn btn-main btn-block" @click="submitForgetPassword()">{{ $PPlusEngine.getDictionary($route.params.lang, 'ขอตั้งรหัสผ่านใหม่', 'Reset Password') }}</button>
                        </div>
                        <section class="group-link">
                            <div class="wrapper">
                                <button class="link" @click="showLogin()">{{ $PPlusEngine.getDictionary($route.params.lang, 'เข้าสู่ระบบ', 'Sign In') }}</button>
                            </div>
                            <div class="wrapper">
                                <span class="link">|</span>
                            </div>
                            <div class="wrapper">
                                <button class="link" @click="showRegister()">{{ $PPlusEngine.getDictionary($route.params.lang, 'ลงทะเบียน', 'Sign Up') }}</button>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import PPlusModal from '@/resources/PPlusModal.js';
import PPlusNotify from '@/resources/PPlusNotify';

export default {
    mixins: [PPlusNotify],
    props: {
        fields: Object
    },
    data() {
        return {
            isActive: false,
            forgetPasswordForm: this.initModelForgetPassword(),
            forgetPasswordValidate: this.initValidateForgetPassword()
        }
    },
    watch: {
        isActive(curr) {
            if (curr) {
                this.$WeHelper.modalScrollable(true);
            }
            else {
                this.$WeHelper.modalScrollable(false);
            }
        }
    },
    methods: {
        show() {
            this.isActive = true;
        },
        hide() {
            this.isActive = false;
        },
        initModelForgetPassword() {
            return { email: '', langCode: this.$route.params.lang };
        },
        initValidateForgetPassword() {
            return { 
                email: { invalid: false, blank: false, format: false },
                form: { invalid: false, message: '' }
            }
        },
        showLogin() {
            let page = this;
            page.hide();
            
            setTimeout(function(){
                page.$PPlusModal.login();
            }, 0);
        },
        showRegister() {
            let page = this;
            page.hide();
            
            setTimeout(function(){
                page.$PPlusModal.register();
            }, 0);
        },
        submitForgetPassword() {
            this.forgetPasswordValidate = this.initValidateForgetPassword();

            if (!this.validateField()) {
                let loader = this.$WeHelper.modalLoad();
                let apiURL = this.$PPlusConfig.ApiURL;

                this.$recaptcha('forgetPassword').then((token) => {
                    this.forgetPasswordForm.recaptcha = token;

                    this.$WeHelper.postAPI(apiURL, '/api/user/forget-password', this.forgetPasswordForm).then((response) => {
                        loader.hide();

                        if (!this.$WeHelper.isNullOrEmpty(response.data)) {
                            if (response.data.success) {
                                this.hide();
                                this.initModelForgetPassword();

                                this.$swal({
                                    title: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'อีเมลถูกส่งไปแล้ว!', 
                                        'Email has been sent'),
                                    text: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'โปรดทำการเช็คอีเมลของท่านเพื่อทำการตั้งรหัสผ่านใหม่', 
                                        'Please check your email to setup your new password'),
                                    type: 'success'
                                });
                            }
                            else {
                                this.forgetPasswordValidate.form.invalid = true;
                                this.forgetPasswordValidate.form.message = response.data.message;
                            }
                        }
                        else {
                            this.alertSystemError();
                        }
                    });
                });
            }
        },
        validateField() {
            var isError = false;

            if (!this.forgetPasswordForm.email) {
                this.forgetPasswordValidate.email.invalid = true;
                this.forgetPasswordValidate.email.blank = true;
                isError = true;
            }
            if (!this.$WeHelper.validateEmail(this.forgetPasswordForm.email)) {
                this.forgetPasswordValidate.email.invalid = true;
                this.forgetPasswordValidate.email.format = true;
                isError = true;
            }

            return isError;
        }
    },
    beforeMount() {
        PPlusModal.EventBus.$on('showForgetPassword', () => {
            this.show();
        });
    }
}
</script>